import { DashboardLayoutConfig } from '../../infrastructure/contracts/layout.contract';

/**
 * Admin Dashboard Layout
 *
 * Reproduces the legacy production grid. Coordinate system: 12-column grid.
 * NOTE: the grid uses CSS auto-placement (DashboardGrid / DashboardLayoutEngine),
 * so VISUAL ORDER follows array order and column span (`w`); `x`/`y` are
 * documentation only.
 *
 * Row 1 — KPI Stats             6 cards × 2 cols
 * Row 2 — Live Operations + Charts
 *   Running Jobs (5) · Lead Velocity (4) · Pipeline Health (3)
 * Row 3 — Team Leaderboard      full width (12)
 * Row 4 — Operational Lists
 *   Pending Tasks (4) · Active Projects (4) · Announcements (4)
 * Row 5 — Recent Activities     (8)
 */
export const adminLayout: DashboardLayoutConfig = {
  id: 'admin-dashboard-layout',
  name: 'Admin Layout',
  description: 'Default layout for Admins',
  role: 'admin',
  widgets: [
    // ── Row 1: KPI Cards ──────────────────────────────────────────
    { id: 'admin-total-leads',      w: 4, h: 1, x: 0,  y: 0 },
    { id: 'admin-leads-today',      w: 4, h: 1, x: 4,  y: 0 },
    { id: 'admin-leads-week',       w: 4, h: 1, x: 8,  y: 0 },
    { id: 'admin-active-employees', w: 4, h: 1, x: 0,  y: 1 },
    { id: 'admin-scans-today',      w: 4, h: 1, x: 4,  y: 1 },
    { id: 'admin-converted-leads',  w: 4, h: 1, x: 8,  y: 1 },

    // ── Row 1.5: Intelligence & Actions ───────────────────────────
    { id: 'dash-ai-briefing',        w: 6, h: 3, x: 0,  y: 2 },
    { id: 'dash-pending-approvals',  w: 6, h: 3, x: 6,  y: 2 },

    // ── Row 2: Live Operations & Charts ───────────────────────────
    { id: 'dash-running-jobs',      w: 12, h: 3, x: 0,  y: 2 },
    { id: 'admin-lead-velocity',    w: 8, h: 4, x: 0,  y: 5 },
    { id: 'admin-pipeline-health',  w: 4, h: 4, x: 8,  y: 5 },

    // ── Row 3: Team Leaderboard (full width) ──────────────────────
    { id: 'admin-team-leaderboard', w: 12, h: 4, x: 0, y: 9 },

    // ── Row 4: Operational Lists ──────────────────────────────────
    { id: 'dash-pending-tasks',     w: 4, h: 4, x: 0,  y: 13 },
    { id: 'dash-active-projects',   w: 4, h: 4, x: 4,  y: 13 },
    { id: 'dash-announcements',     w: 4, h: 4, x: 8,  y: 13 },

    // ── Row 5: Upcoming Meetings + Notifications ──────────────────
    { id: 'dash-upcoming-meetings', w: 6, h: 4, x: 0,  y: 17 },
    { id: 'dash-notifications',     w: 6, h: 4, x: 6,  y: 17 },
    { id: 'dash-recent-activities', w: 12, h: 4, x: 0, y: 21 },
  ],
};
